import { api } from '../api';
import { authService } from './AuthService';

const loginUser = async (user) => {
  const loginResponse = await api.post(`/auth/login`, user);
  return loginResponse;
};

const logoutUser = async () => {
  try {
    if (process.env.REACT_APP_SSO_ENABLED !== 'false') {
      api.post(`/auth/logout`);
      await authService.logout();
    } else {
      await api.post(`/auth/logout`);
      window.location.replace('/#/login');
      window.location.reload();
    }
  } catch (error) {
    console.error('Logout failed:', error);
    window.location.replace('/#/');
  }
};

const extendUserSession = async () => {
  const res = await api.post('/auth/extend');
  sessionStorage.removeItem('toastShown');
  return res;
};

export {
  loginUser,
  logoutUser,
  extendUserSession,
}
